import React, { useState } from 'react';
import { TextField } from '@mui/material';

import { TextOperationService } from '../../../services';
import {
  DEFAULT_CONTINUE_TEXT_STATE,
  buildContinueTextRequest,
  type ContinueTextFormState,
} from './buildRequests';
import { useRunTextOperation } from './useTextOperationMutation';
import { TEXT_OPERATION_CATALOG } from './operationCatalog';
import { PanelScaffold } from './PanelScaffold';
import type { TextPanelProps } from './panelProps';

export const ContinuePanel: React.FC<TextPanelProps> = ({
  ensureSession,
  isCreatingSession = false,
  documentId,
  sectionId,
  onResult,
}) => {
  const [state, setState] = useState<ContinueTextFormState>(DEFAULT_CONTINUE_TEXT_STATE);
  const { run, mutation, validationError } = useRunTextOperation(
    TextOperationService.continue_,
    ensureSession,
    documentId,
    { onResult },
  );

  const needsDocument = !documentId;
  const handleSubmit = () => run((sid, docId) => buildContinueTextRequest(state, sid, docId, sectionId));

  return (
    <PanelScaffold
      meta={TEXT_OPERATION_CATALOG.Continue}
      needsDocument={needsDocument}
      validationError={validationError}
      mutationError={mutation.isError ? mutation.error : null}
      busy={mutation.isPending}
      starting={isCreatingSession}
      submitDisabled={mutation.isPending || isCreatingSession || needsDocument}
      submitLabel="Continue"
      busyLabel="Continuing…"
      onSubmit={handleSubmit}
    >
      <TextField
        label="Target words"
        type="number"
        value={state.targetWordCount}
        onChange={e => setState(s => ({ ...s, targetWordCount: Number(e.target.value) }))}
        size="small"
        inputProps={{ min: 50, max: 2000, step: 50 }}
        // See GeneratePanel — a bare number input is narrower than its label,
        // which clips the outlined legend.
        fullWidth
        sx={{ minWidth: 150 }}
      />
    </PanelScaffold>
  );
};
